module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabBox wrapper-content fadeInRight animated",
    staticStyle: {
      "background": "#fff"
    },
    attrs: {
      "id": "homeBulletin"
    }
  }, [_c('div', {
    staticClass: "home_box"
  }, [_c('div', {
    staticClass: "home_pic"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/project/images/picc.jpg"),
      "alt": "",
      "width": "400"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "home_txt"
  }, [_vm._v("欢迎进入人保救援车辆GPS平台系统")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02220acc","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/PageBulletin.vue
// module id = 1399
// module chunks = 0